import { useGlobalStore } from '../../zustand-store/useGlobalStore';

export const NO_ENOUGH_CREDITS = 'NO_ENOUGH_CREDITS';

// The feature create endpoints return HTTP 200 with { success:false, failure_type:
// 'NO_ENOUGH_CREDITS' } when the pre-flight credit gate rejects the job. This surfaces the
// global upgrade modal (same UX as the TTS composer) and throws so the mutation resolves as an
// error — stopping the caller's success path. Callers can check `err.handled` to skip a
// redundant error toast. No-op on a normal success response.
export function assertFeatureCreditsOk(response: any) {
    if (response?.data?.failure_type === NO_ENOUGH_CREDITS) {
        useGlobalStore.getState().toggleUpgradeModal(true, { title: response.data.message });
        const err: any = new Error(NO_ENOUGH_CREDITS);
        err.failure_type = NO_ENOUGH_CREDITS;
        err.handled = true;
        throw err;
    }
}
